/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmBatchesGet } from "../../funcs/llmBatchesGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetBatchRequest$inboundSchema,
};

export const tool$llmBatchesGet: ToolDefinition<typeof args> = {
  name: "llm-batches-get",
  description: `Get a batch

Retrieves a batch by its ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmBatchesGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
